import { useSyncExternalStore } from "react";
import { useAuth } from "../auth/AuthContext";
import { extractPermissions } from "../project/jwtClaims";
import { authzStore } from "./authzStore";

const REQUIRED_PERMISSION = "Subject_Read";

/**
 * PRD-005: shared client-side authorization check used by the gate and the
 * sidebar's hidden-nav. Returns true when the user holds a JWT that carries
 * `Subject_Read` AND no mid-session 403 has been observed. Pre-auth
 * (`jwt === null`) returns `false` — the sidebar's export icon stays hidden
 * until the user authenticates and the claim is confirmed.
 */
export function useIsAuthorized(): boolean {
    const { jwt } = useAuth();
    const forcedDeny = useSyncExternalStore(
        authzStore.subscribe,
        authzStore.get,
        () => false,
    );
    if (jwt === null) return false;
    if (forcedDeny) return false;
    return extractPermissions(jwt).includes(REQUIRED_PERMISSION);
}
